exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search.x-row {\n  align-items: flex-start;\n}\n.has-more {\n  color: red;\n  font-weight: 700;\n}\nspan.vc-bg-green-600 {\n  height: 30px !important;\n  opacity: 20%;\n}\n", ""]);

// exports
